export default __webpack_public_path__ + "static/media/servicios-img-2.74aacab5.svg";